module.exports = __webpack_public_path__ + "static/media/17.4b15106b.JPG";